import React, { useRef, useState } from "react";
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send'
import emailjs from "emailjs-com";
import { useHistory } from "react-router";
const Contact = (props) => {
  const initialState = {
    name: "",
    email: "",
    message: "",
    error: "",
    success: "",
  };
  const form = useRef();
  const [valid, setValid] = useState(initialState);

  const { toggleContact } = props;
  const history = useHistory();
  const handleBack = () => {
    console.log(history);
    toggleContact();
    history.push("/");
  };

  const validate = () => {
    let error = "";
    if (valid.name === "" || valid.email === "" || valid.message === "") {
      error = "Please fill out all fields";
    }

    if (error) {
      setValid({
        ...valid,
        error: error,
      });
      return false;
    }

    return true;
  };
  const handleChange = (e) => {
    setValid({
      ...valid,
      [e.target.name]: e.target.value,
    });
  };

  const sendEmail = (e) => {
    e.preventDefault();
    const isValid = validate();
    if (isValid) {
      emailjs
        .sendForm(
          "service_alo5hz7",
          "template_09stt05",
          form.current,
          "user_1jk1nQOxmdBkAh35v4Lxf"
        )
        .then(
          (result) => {
            console.log(result.text);
          },
          (error) => {
            console.log(error.text);
          }
        );
      setValid(initialState);
      e.target.reset();
      setValid({
        ...valid,
        success: "Message Sent! Thank you!",
        error: "",
      });
    }
  };
  return (
    <div className="contact-container">
      <div className="flex-container">
        <h2 className="contact-send-message">Send me a message!</h2>
        <div className="contact-form-container">
          <form className="form-styles" ref={form} onSubmit={sendEmail}>
            <label className="input-desc">
              {" "}
              <h3>Name</h3>
              <input
                onChange={handleChange}
                type="text"
                name="name"
                value={valid.name}
              />
            </label>
            <label className="input-desc">
              {" "}
              <h3>Email</h3>
              <input
                onChange={handleChange}
                className="email"
                type="email"
                name="email"
                value={valid.value}
              />
            </label>
            <label className="input-desc">
              {" "}
              <h3>Message</h3>
              <textarea
                onChange={handleChange}
                id="contact-message"
                name="message"
                value={valid.value}
              />
            </label>
            <Button className="send-btn" type="submit" variant="contained" endIcon={<SendIcon />}>
              <span>Send</span>
            </Button>
            
            <div></div>
            <p className="success">{valid.success && valid.success}</p>
            <p className={valid.error ? "error" : ""}>{valid.error}</p>
          </form>
        </div>
      </div>

      <div className="back-button" onClick={handleBack}>
        Back
      </div>
    </div>
  );
};

export default Contact;
